var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nft-collection-table"},[_c('nft-scrollable-table',{attrs:{"default-sort-key":_vm.isHomepage ? 'order' : '30-DAY VOLUME',"items":_vm.collection.items,"show-view-all":_vm.isHomepage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }